/**
 * 个人中心-上传头像弹窗
 * created by chenhao 2017-12-5
 */
"use stricted";
angular.module("changeNumberModule", ["validationRuleModule"])
	.controller("changeNumberCtrl", ['$scope', '$element', '$validation', '$interval', '$modalInstance', 'number', 'httpService', '$q', 'modalDialog', function ($scope, $element, $validation, $interval, $modalInstance, number, httpService, $q, modalDialog) {
		initStatus();
		initData();

		function initStatus() {
			$scope.status = {
				verificationCode: "/mcnww/web/code/image.do?V=12345678",
				send: false, //发送按钮置灰
				time: 60,
				btnstatus: true,
				m: false, //判断手机是否重复的提示信息是否显示,
				mb: false, //手机号校验失败后显示红色框
				y: false, //存储手机号是否通过校验
				codemsg: false, //判断验证码是否是正确的
				isFirstSend: true, //是否第一次点击发送
				isDisabled: false,
			};
			$scope.info = {
				mobile: '',
				smsValidCode: '',
				validCode: "",
			};
		}

		function initData() {
			loadEncryptionLib().then(function () {
				encryptionMethods();
			});
		}
		/**
		 * [encryptionMethods description] 加密方法
		 * @return {[type]} [description]
		 */
		function encryptionMethods() {
			$.ajax({
				url: "/mcnww/web/user/publicKey.do",
				// headers:{requestToken:sessionStorage.getItem('requestToken'),"Content-Type":"text/plain;charset=UTF-8"},
				dataType: "text",
				success: function (data) {
					$("#encryption").remove();
					$("body").append("<script id='encryption'>" + data + "</script>");
				}
			});
		}
		/**
		 * [loadEncryptionLib description] 加载加密依赖文件
		 * @return {[type]} [description]
		 */
		function loadEncryptionLib() {
			var deffer = $q.defer();
			LazyLoad.js(["static/rsa/RSA.js", "static/rsa/BigInt.js", "static/rsa/Barrett.js"], function () {
				deffer.resolve();
			});
			return deffer.promise;
		}
		/**
		 * [SMScode description] 短信验证码 发送
		 * @return {[type]} [description]
		 */
		$scope.SMScode = function () {
			$scope.status.isFirstSend = false;
			$scope.status.send = true;
			if ($scope.status.y) {
				var params = {
					mobile: $scope.info.mobile
				};
				httpService.http("/mcnww/web/code/sms.do", params, "post", true, true).then(function (result) {
					if (!result.success) {
						modalDialog.success(result.message, "success", false, function () {}, function () {}, '', 'getCodeError');
						$scope.updateImg();
					} else {
						$scope.status.send = false;
						modalDialog.success("验证码已发送至您的手机，请注意查收", "success", false, function () {}, function () {}, '', 'getCodeSuccess');
						countDown();
					}
				});
			}
		};
		/**
		 * [updateImg description] 更新验证码
		 * @return {[type]} [description]
		 */
		$scope.updateImg = function () {
			var imgArray = $scope.status.verificationCode.split("=");
			imgArray[1] = Math.random();
			$scope.status.verificationCode = imgArray.join("=");
		};

		/**
		 * [countDown description] 倒计时
		 * @return {[type]} [description]
		 */

		function countDown() {
			var timer = $interval(function () {
				$scope.status.time--;
				if ($scope.status.time == 0) {
					$interval.cancel(timer);
					$scope.status.time = 60;
				}
			},1000);
		}

		/**
		 * [cancel description] 取消
		 * @return {[type]} [description]
		 */
		$scope.cancel = function () {
			$modalInstance.dismiss();
		};
		/**
		 * [confirm description] 确定
		 * @return {[type]} [description]
		 */
		$scope.confirm = function () {
			$validation.validate($scope.formOne).success(function () {
				var params = {
					mobile: $scope.info.mobile,
					captchaToken: $scope.info.validCode,
					MbValidCode: $scope.info.smsValidCode
				};
				httpService.http("/mcnww/web/ucenter/updateMobile.do", params, "post", true, true).then(function (result) {
					if (!result.success) {
						modalDialog.success(result.message, "success", false, function () {}, function () {}, '', 'changePhoneSuccess');
						$scope.updateImg();
					} else {
						modalDialog.success("修改手机号成功", "success", false, function () {
							$modalInstance.close();
						}, function () {}, '', 'changePhoneSuccess');
					}
				});
				$scope.status.isDisabled = false;
			}).error(function () {
				angular.invalidPosition($scope.formOne, $element);
			});

		};
		/**
		 * [checkMobile description] 检查手机号是否存在
		 * @params {[obj]}[description]参数
		 * @return {[type]} [description]
		 */
		$scope.checkMobile = function (obj) {
			var phoneReg = /^(1[2-9][0-9])\d{8}$/;
			if (phoneReg.test(obj.param)) {
				httpService.http("/mcnww/web/user/existsValid.do", obj, "post").then(function (data) {
					if (data.status === 'n') {
						$scope.status.m = true;
						$scope.status.y = false;
						$scope.status.mb = true;
					} else {
						$scope.status.m = false;
						$scope.status.y = true;
						$scope.status.mb = false;
					}
				});
			}
		};
		/**
		 * [isEmpty description]输入验证码是否为空
		 * @param  {[type]}  validCode [description]
		 * @return {Boolean}           [description]
		 */
		$scope.isEmpty = function (validCode) {
			if (validCode.length != 4) {
				$scope.status.isDisabled = false;
			} else {
				httpService.http("/mcnww/web/code/valid.do", {
					name: 'captchaToken',
					param: validCode
				}, "post").then(function (data) {
					if (data.status === 'n') {
						$scope.status.isDisabled = false;
						$scope.status.codemsg = true;
					} else {
						$scope.status.codemsg = false;
						$scope.status.isDisabled = true;
					}
				});
			}

		};
	}]);
